import { render, staticRenderFns } from "./ExchangeInfo.vue?vue&type=template&id=4b1f27b8&scoped=true"
import script from "./ExchangeInfo.vue?vue&type=script&lang=js"
export * from "./ExchangeInfo.vue?vue&type=script&lang=js"
import style0 from "./ExchangeInfo.vue?vue&type=style&index=0&id=4b1f27b8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f27b8",
  null
  
)

export default component.exports